<template>
  <div class="wrapper" v-if="current.duration" :key="current.id">
    <div class="spinner pie" :style="{'--time': current.duration+'s'}" :class="urgency"></div>
    <div class="filler pie" :style="{'--time': current.duration+'s'}" :class="urgency"></div>
    <div class="mask" :style="{'--time': current.duration+'s'}"></div>
  </div>
</template>

<script>
export default {
  name: 'PieTimer',
  props: ['current'],
  data () {
    return {
      timeRemaining: null
    }
  },
  mounted () {
    this.timeRemaining = this.current.duration
    this.countDown();
  },
  methods: {
    countDown () {
      if ( this.timeRemaining >= 0 ) {
        setTimeout(() => {
          this.timeRemaining--
          this.countDown();
        }, 1000);
      }
    }
  },
  computed: {
    timeRemainingConverted () {
      const format = val => `0${Math.floor(val)}`.slice(-2)
      let timeArray = [];
      if (this.timeRemaining > 3600) {
        timeArray.push(this.timeRemaining / 3600)  
      } 
      timeArray.push((this.timeRemaining % 3600) / 60);
      timeArray.push(this.timeRemaining % 60);

      return timeArray.map(format).join(':')
    },
    urgency () {
      const percentageRemaining =  this.timeRemaining / this.current.duration * 100;
      if ( percentageRemaining < 25 ) {
        return 'urgent'
      } else if ( percentageRemaining < 50 ) {
        return 'medium'
      }
      return 'normal';
    }
  },
  watch: {
    current (val) {
      this.timeRemaining = val.duration
    }
  }
}
</script>

<style lang="scss" scoped>

/* Variables : your settings */

$animation-duration : 10s;
$size : 40px; /* Any unit */
$main-color : #21D64C; /* No gradients */
$background-color : #3D3DDE; /* No gradients */
$border: none; /* Set "none" if you don't want */
$hover-play-state : running; /* Set "running" if you don't want to pause the animation on hover */
$demo-content-display : none; /* Set "block" to see we can make content on the spinner and watch it rotates */


.wrapper { 
  width: $size;
  height :$size;
  background: $background-color !important; 
  border-radius: 50%;
  overflow: hidden;

  position: absolute;
  right: 20px;
  top: 15px;
  z-index: 30 !important;
}

.pie {
  width: 50%;
  height: 100%;
  transform-origin: 100% 50%;
  position: absolute;
  background: $main-color;
  border: $border;

  transition: all 2s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;

  &.normal {
    background-color: #21D64C;
  }
  &.medium {
    background-color: #e1651d;
  }
  &.urgent {
    background-color: #e1241d;
  }
}

.spinner {
  border-radius: 100% 0 0 100% / 50% 0 0 50%;
  z-index: 200;
  border-right:none;
  animation: rota $animation-duration linear both;
  animation-duration: var(--time);
}

.wrapper:hover .spinner,
.wrapper:hover .filler, 
.wrapper:hover .mask {
    animation-play-state: $hover-play-state;    
}

.spinner:after {
    position:absolute;
    width:10px;
    height:10px;
    background:#fff;
    border:1px solid rgba(0,0,0,0.5);
    box-shadow: inset 0 0 3px rgba(0,0,0,0.2);
    border-radius:50%;
    top:10px;
    right:10px;   
    content:"";
    display: $demo-content-display;
}

.filler {
  border-radius: 0 100% 100% 0 / 0 50% 50% 0; 
  left: 50%;
  opacity: 0;
  z-index: 100;
  animation: fill $animation-duration steps(1,end) both;
  animation-duration: var(--time);
  border-left: none;
}

.mask {
  width: 50%;
  height: 100%;
  position: absolute;
  background: inherit;
  opacity: 1;
  z-index: 300;
  animation: mask $animation-duration steps(1,end) both;
  animation-duration: var(--time);
}

@keyframes rota {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes mask {
  0% { opacity: 1; }
  50%, 100% { opacity: 0; }
}

@keyframes fill {
  0% { opacity: 0; }
  50%, 100% { opacity: 1; }
} 
</style>